import { useRouteParams as useRouteParamsBase } from '../../_hooks/useRouteParams';

interface RouteParams {
  clientId: string;
  redirectTo?: 'profile' | 'comprehensive' | 'assetBucketing' | 'beFi';
}

export const useRouteParams = () => {
  return useRouteParamsBase<RouteParams>();
};
